// extracted by mini-css-extract-plugin
export default {"drawerOpen":"App_drawerOpen__S65xg"};